import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.less']
})
export class PopoverComponent implements OnInit {

  @Input() questionsForVariable: any[];
  @Output() questionIdForVariable: EventEmitter<number> = new EventEmitter<number>();

  constructor() {
  }

  ngOnInit() {
  }

  selectQuestionId(q) {
    if (q.id)
      this.questionIdForVariable.emit(q.id);
    else
      this.questionIdForVariable.emit(q.guid);
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/components/popover/popover.component.ts